module.exports = __webpack_public_path__ + "static/media/favorited.0aa442e2.svg";